import { render, staticRenderFns } from "./OrderStage.vue?vue&type=template&id=2c45a0b2"
import script from "./OrderStage.vue?vue&type=script&lang=js"
export * from "./OrderStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports